import JSZip from "jszip";

const OWNER = "Andrea1904";
const REPO = "reviewPresentation";
const WORKFLOW_FILE = "ado-query.yml";

function githubHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
    Accept: "application/vnd.github+json",
    "X-GitHub-Api-Version": "2022-11-28",
  };
}

async function githubFetch(url, token, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: { ...githubHeaders(token), ...options.headers },
  });
  if (!response.ok) {
    const detail = await response.text();
    throw new Error(`GitHub API ${response.status}: ${detail.slice(0, 240)}`);
  }
  return response;
}

async function waitForRun(token, requestId) {
  const deadline = Date.now() + 180000;
  while (Date.now() < deadline) {
    await new Promise((resolve) => setTimeout(resolve, 4000));
    const response = await githubFetch(
      `https://api.github.com/repos/${OWNER}/${REPO}/actions/runs?event=workflow_dispatch&per_page=25`,
      token,
    );
    const data = await response.json();
    const run = (data.workflow_runs || []).find((item) => item.name === `ado-${requestId}`);
    if (run?.status === "completed") return run;
  }
  throw new Error("GitHub Actions tardó demasiado en responder.");
}

async function downloadResult(token, runId) {
  const list = await githubFetch(
    `https://api.github.com/repos/${OWNER}/${REPO}/actions/runs/${runId}/artifacts`,
    token,
  );
  const artifacts = (await list.json()).artifacts || [];
  const artifact = artifacts.find((item) => item.name === "ado-result");
  if (!artifact) throw new Error("No se encontró el resultado de GitHub Actions.");
  const zipResponse = await githubFetch(artifact.archive_download_url, token);
  const zip = await JSZip.loadAsync(await zipResponse.arrayBuffer());
  const file = zip.file("result.json");
  if (!file) throw new Error("El artefacto de GitHub Actions no contiene result.json.");
  return JSON.parse(await file.async("string"));
}

export async function runAdoJob({ githubToken, kind, team, iterationId = "" }) {
  if (!githubToken) throw new Error("Falta el token de GitHub para consultar desde Pages.");
  const requestId = crypto.randomUUID();
  await githubFetch(
    `https://api.github.com/repos/${OWNER}/${REPO}/actions/workflows/${WORKFLOW_FILE}/dispatches`,
    githubToken,
    {
      method: "POST",
      body: JSON.stringify({
        ref: "main",
        inputs: {
          request_id: requestId,
          kind,
          team,
          iteration_id: iterationId,
        },
      }),
    },
  );
  const run = await waitForRun(githubToken, requestId);
  if (run.conclusion !== "success") {
    throw new Error("La consulta a Azure DevOps desde GitHub Actions falló. Revisa el workflow y el secreto AZURE_DEVOPS_PAT.");
  }
  return downloadResult(githubToken, run.id);
}

export function shouldUseGitHubActions({ githubToken, proxyUrl, serverManagedAuth }) {
  return Boolean(githubToken && !serverManagedAuth && !proxyUrl);
}
